export const FileIcon = ({
  color = 'var(--primary)', size = '24', label = 'file icon', ...props
}: { color?: string, size?: string, label?: string }) => (
  <svg
    {...props}
    xmlns={'http://www.w3.org/2000/svg'}
    height={size}
    width={size}
    viewBox={'0 0 24 24'}
    fill={'none'}
    {...props}
  >
    <title>{label}</title>
    <path
      d={'M6 22.138C5.45 22.138 4.97917 21.9408 4.5875 21.5464C4.19583 21.152 4 20.678 4 20.1242V4.01382C4 3.46003 4.19583 2.98595 4.5875 2.59158C4.97917 2.19721 5.45 2.00003 6 2.00003H13.175C13.4417 2.00003 13.6958 2.05038 13.9375 2.15107C14.1792 2.25175 14.3917 2.3944 14.575 2.579L19.425 7.46245C19.6083 7.64704 19.75 7.86101 19.85 8.10434C19.95 8.34768 20 8.6036 20 8.8721V20.1242C20 20.678 19.8042 21.152 19.4125 21.5464C19.0208 21.9408 18.55 22.138 18 22.138H6ZM13 8.04141C13 8.3267 13.0958 8.56584 13.2875 8.75882C13.4792 8.95181 13.7167 9.04831 14 9.04831H18L13 4.01382V8.04141Z'}
      fill={color}
    />
  </svg>
);
